<template>
  <!-- :style="{border: '1px solid' + itemIndex == index ? '#ff0000' : '#fff'}" -->
  <div class="assembling-label-flex" id="body">
    <div :style="{ display: !login ? 'none' : 'inline' }" style="width: 100%;">
      <canvas id="assembling" style="opacity: 0;position: absolute;z-index: -100;"></canvas>
      <img :src="imgurl" :style="{'width':'100%','marginTop': marginTop}" id="canvasImg"/>
      <div style="width: 100%;height: 13rem;"></div>
      <div class="assembling-label-div" v-if="tablist.length != 0" id="canvasLabel">
        <van-tabs class="more-van-tabs" line-height="1px" title-active-color="#ff0000" @click="clickTap" v-if="tablist[0].name.length != 0" v-model="tabIndex" :ellipsis="false">
          <van-tab v-for="(item, index) in tablist" :key="index" :title="item.name" :disabled="item.name.length != 0 ? false : true"></van-tab>
        </van-tabs>
        <scroll-view class="assembling-label-img" @bindscroll="bindscroll">
          <div style="width: 5rem;display: inline-block;margin-right: 3rem;" v-for="(item, index) in tablist[tabIndex].pic_list" :key="index" @click="canvas_loadAssemb(item,index)">
            <div class="assembling-label-img-item" :style="{border: '1px solid' + (itemIndex == index ? '#ff0000' : '#efeff4'),color:(itemIndex == index ? '#ff0000' : '#999')}">
              <lazyImage :imgUrl="item.show_url" :scrollLeft="scrollLeft" class="assembling-label-img-item-lazyImage"></lazyImage>
              <span>{{ item.pic_name }}</span>
            </div>
          </div>
        </scroll-view>
      </div>
    </div>
    <div :style="{ display: login ? 'none' : 'inline' }"><loadMore :loadingType="1" style="width: 100%;"></loadMore></div>
  </div>
</template>

<script>
import { AlbumframegetFrame, AlbumgetBaseInfo } from '@/request/api.js';
import { Tab, Tabs } from 'vant';
import config from '@/assets/js/config.js';

export default {
  mixins: [config],
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
  },
  data() {
    return {
      canvasObject: null,
      tabIndex: 0,
      itemIndex: 0,
      tablist: [],
      imgurl: '',
      pic_id: 0,
      markData: {
        mark_type: 2,
      },
      login: true,
      scrollLeft: 0,
      pic_url: null,
      title: '',
      marginTop: '10%',
    };
  },
  mounted() {
    const param = this.$api.parseUrl();
    if (param) {
      this.pic_id = param.pic_id;
    }
    // document.getElementById('body').innerHTML='<p>11</p>'
    this.getDir_loadAssemb();
    this.onMenuShareAssemb();
  },
  watch: {
    tabIndex() {
      if (this.tablist.length != 0 && this.tablist[this.tabIndex].pic_list.length > 0) {
        this.canvas_loadAssemb(this.tablist[this.tabIndex].pic_list[0], 0);
      }
    },
  },
  created() {},
  methods: {
    async onMenuShareAssemb() {
      const _self = this;
      const link = `https://huace.9071design.com/wap/#/assembling?pic_id=${this.pic_id}&alias=${this.$store.state.loginInfo.album_alias}`;
      const res = await AlbumgetBaseInfo('');
      this.wx_config([
        'checkJsApi',
        'onMenuShareTimeline',
        'onMenuShareAppMessage',
        'onMenuShareQQ',
        'onMenuShareWeibo',
        'chooseWXPay',
        'updateAppMessageShareData',
        'updateTimelineShareData',
      ]).then((wx) => {
        wx.onMenuShareAppMessage({
          title: res.data.name, // 分享标题
          desc: res.data.share_desc,
          link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: res.data.cover_image_text, // 分享图标
          type: 'link', // 分享类型,music、video或link，不填默认为link
          dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
          success() {
            // 用户点击了分享后执行的回调函数
          },
        });
        wx.onMenuShareTimeline({
          title: res.data.name, // 分享标题
          link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: res.data.cover_image_text, // 分享图标
          success() {
            // 用户确认分享后执行的回调函数
          },
          cancel() {
            // 用户取消分享后执行的回调函数
          },
        });
        wx.updateAppMessageShareData({
          title: res.data.name, // 分享标题
          desc: res.data.share_desc,
          link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: res.data.cover_image_text, // 分享图标
          success() {
            // 设置成功
          },
        });
        wx.updateTimelineShareData({
          title: res.data.name, // 分享标题
          link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: res.data.cover_image_text, // 分享图标
          success() {
            // 设置成功
          },
        });
        _self.login = true;
      });
    },
    async getDir_loadAssemb() {
      const res = await AlbumframegetFrame({
        pic_id: this.pic_id,
      });
      let listTength = 4;
      let tablist;
      this.pic_url = res.data.cover_image;
      tablist = res.data.frameItem_list;
      this.title = res.data.title;
      listTength -= tablist.length;
      if (listTength > 0) {
        for (let index = 0; index < listTength; index++) {
          tablist.push({
            name: '',
            local_url: index,
          });
        }
      }
      // tablist.unshift({
      //   name: res.data.name,
      //   pic_list: [{
      //     show_url: res.data.cover_image,
      //     show_url1: res.data.pic_url,
      //     pic_name: res.data.cover_title,
      //   }],
      // });
      this.tablist = tablist;
      this.markData = res.data.markData;
      this.canvas_loadAssemb(tablist[0].pic_list[0], 0);
    },
    clickTap(item) {
      this.tabIndex = item;
    },
    canvas_loadAssemb(item, index = 1) {
      this.itemIndex = index;
      if (index == 0) {
        this.imgurl = item.show_url1;
      }
      const canvasById = document.getElementById('assembling');
      const img = new Image();
      img.crossOrigin = '*';
      img.src = item.local_url;
      img.onload = () => {
        canvasById.width = item.pic_width;
        canvasById.height = item.pic_height;
        const canvasByTx = canvasById.getContext('2d');
        canvasByTx.drawImage(img, 0, 0, item.pic_width, item.pic_height);
        this.canvasObject = {
          canvasByTx,
          width: item.pic_width,
          height: item.pic_height,
          canvasById,
        };
        this.canvasReplaceAssemb(item);
      };
    },
    canvasReplaceAssemb(item) {
      const { canvasById } = this.canvasObject;
      const { canvasByTx } = this.canvasObject;
      const img = new Image();
      img.crossOrigin = '*';
      img.src = this.pic_url;
      img.onload = () => {
        const clientWidth = parseInt(item.width);
        const clientHeight = parseInt(item.height);

        canvasByTx.globalCompositeOperation = 'destination-over';
        // canvasByTx.globalCompositeOperation = 'source-over';
        canvasByTx.drawImage(img, parseInt(item.coordinate_X), parseInt(item.coordinate_Y), clientWidth, clientHeight);

        canvasByTx.globalCompositeOperation = 'source-over';
        canvasByTx.font = '23px "微软雅黑"'; // 设置字体
        canvasByTx.textBaseline = 'bottom'; // 设置字体底线对齐绘制基线
        canvasByTx.textAlign = 'left'; // 设置字体对齐的方式
        canvasByTx.fillText(`${this.title}-${item.pic_name}`, 30, 50); // 设置左边标题

        this.canvasObject.canvasByTx = canvasByTx;
        this.canvasLogoAssemb();
        // const base64 = canvasById.toDataURL();
        // this.afterReadAssemb(base64);
      };
    },
    canvasLogoAssemb() {
      const attribute = this.tablist[this.tabIndex];
      const { canvasById } = this.canvasObject;
      const { canvasByTx } = this.canvasObject;
      const clientWidth = parseInt(this.canvasObject.width);
      const clientHeight = parseInt(this.canvasObject.height);
      canvasByTx.globalCompositeOperation = 'source-over';
      if (this.markData.mark_type == 0) {
        canvasByTx.font = '23px "微软雅黑"'; // 设置字体
        canvasByTx.textBaseline = 'bottom'; // 设置字体底线对齐绘制基线
        canvasByTx.textAlign = 'left'; // 设置字体对齐的方式
        canvasByTx.fillText(this.markData.mark_word, clientWidth - this.markData.mark_word.length * 23 - 30, clientHeight - 30); // 填充文字
        const base64 = canvasById.toDataURL();
        this.afterReadAssemb(base64);
      } else if (this.markData.mark_type == 1) {
        const img = new Image();
        img.crossOrigin = '*';
        img.src = this.markData.mark_image_text;
        img.onload = () => {
          canvasByTx.drawImage(
            img,
            clientWidth - clientWidth * 0.2 - 80,
            clientHeight - clientHeight * 0.2 - 80,
            clientWidth * 0.2,
            ((clientWidth * 0.2) / img.width) * img.height,
          );
          const base64 = canvasById.toDataURL();
          this.afterReadAssemb(base64);
        };
      }
    },
    async afterReadAssemb(base64) {
      this.imgurl = base64;
      const canvasImg = document.getElementById('canvasImg');
      const canvasLabel = document.getElementById('canvasLabel');
      canvasImg.onload = () => {
        this.marginTop = `${(document.body.clientHeight - canvasLabel.clientHeight) / 2 - canvasImg.clientHeight / 2}px`;
      };
    },
    getPixelRatioAssemb(context) {
      const backingStore = context.backingStorePixelRatio
        || context.webkitBackingStorePixelRatio
        || context.mozBackingStorePixelRatio
        || context.msBackingStorePixelRatio
        || context.oBackingStorePixelRatio
        || context.backingStorePixelRatio
        || 1;
      return (window.devicePixelRatio || 1) / backingStore;
    },
    bindscroll(event) {
      this.scrollLeft = event.left;
    },
  },
};
</script>

<style lang="less">
.assembling-label-flex {
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: true;
  .assembling-label-div {
      width: 100%;
      display: flex;
      flex-direction: column;
      position: fixed;
      bottom: 0;
      border: none;
      background-color: #ffffff;
      padding: 10px 0;
      transition: 0.5s;
      z-index: 1200;
      background-color: #efeff4;
    }

    .more-van-tabs {
      width: 100%;
    }

    .assembling-label-img {
      width: 90%;
      padding: 0 5%;
      height: 6rem;
      margin-top: 1rem;
    }

    .assembling-label-img-item {
      width: 100%;
      display: flex;
      flex-direction: column;
      color: #999;
      align-items: center;
      font-size: 0.7rem;
    }

    .assembling-label-img-item-lazyImage {
      width: 4rem;
      height: 4rem;
      margin-bottom: 0.2rem;
    }
    .assembling-label-img-item > span {
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      white-space: pre-wrap;
    }
    .van-tabs__nav{
      background-color: #efeff4 !important;
    }
}
</style>
